import { SETTINGS_TEMPLATE_ID_SEARCH_PARAM } from "@/app/router/appRoutes";
import { AGENT_IDENTITY_SEARCH_PARAMS, AGENT_SEARCH_PARAMS } from "@/store/agent-overlay/types";

export const SETTINGS_SEARCH_PARAM = "settings";

const SETTINGS_SEARCH_PARAMS = [SETTINGS_SEARCH_PARAM, SETTINGS_TEMPLATE_ID_SEARCH_PARAM] as const;

const withoutSearchParams = ({
  searchParams,
  searchParamNames,
}: {
  searchParams: URLSearchParams;
  searchParamNames: readonly string[];
}) => {
  const nextSearchParams = new URLSearchParams(searchParams);

  for (const searchParamName of searchParamNames) {
    nextSearchParams.delete(searchParamName);
  }

  return nextSearchParams;
};

export const hasAgentSearchParams = ({ searchParams }: { searchParams: URLSearchParams }) =>
  AGENT_SEARCH_PARAMS.some(searchParamName => searchParams.has(searchParamName));

export const withoutAgentIdentitySearchParams = ({
  searchParams,
}: {
  searchParams: URLSearchParams;
}) =>
  withoutSearchParams({
    searchParams,
    searchParamNames: AGENT_IDENTITY_SEARCH_PARAMS,
  });

export const withoutAgentSearchParams = ({ searchParams }: { searchParams: URLSearchParams }) =>
  withoutSearchParams({
    searchParams,
    searchParamNames: AGENT_SEARCH_PARAMS,
  });

export const withoutSettingsSearchParams = ({ searchParams }: { searchParams: URLSearchParams }) =>
  withoutSearchParams({
    searchParams,
    searchParamNames: SETTINGS_SEARCH_PARAMS,
  });
